// Partner statuses
export const PARTNER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
};

export const PARTNER_STATUS_LABELS = {
  [PARTNER_STATUS.ACTIVE]: 'Active',
  [PARTNER_STATUS.INACTIVE]: 'Inactive',
  [PARTNER_STATUS.SUSPENDED]: 'Suspended',
};

export const PARTNER_STATUS_COLORS = {
  [PARTNER_STATUS.ACTIVE]: 'success',
  [PARTNER_STATUS.INACTIVE]: 'default',
  [PARTNER_STATUS.SUSPENDED]: 'error',
};

// Clinic statuses
export const CLINIC_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const CLINIC_STATUS_LABELS = {
  [CLINIC_STATUS.ACTIVE]: 'Active',
  [CLINIC_STATUS.INACTIVE]: 'Inactive',
};

export const CLINIC_STATUS_COLORS = {
  [CLINIC_STATUS.ACTIVE]: 'success',
  [CLINIC_STATUS.INACTIVE]: 'default',
};

// Days of week
export const DAYS_OF_WEEK = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
];

// Language codes
export const LANGUAGES = {
  RO: 'ro',
  RU: 'ru',
  EN: 'en',
};

export const LANGUAGE_LABELS = {
  [LANGUAGES.RO]: 'Romanian',
  [LANGUAGES.RU]: 'Russian',
  [LANGUAGES.EN]: 'English',
};

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

// Logo upload constraints
export const LOGO_MAX_SIZE = 2 * 1024 * 1024; // 2MB
export const LOGO_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/svg+xml'];

// Default working hours
export const DEFAULT_WORKING_HOURS = {
  monday: { is_open: true, open_time: '09:00', close_time: '18:00' },
  tuesday: { is_open: true, open_time: '09:00', close_time: '18:00' },
  wednesday: { is_open: true, open_time: '09:00', close_time: '18:00' },
  thursday: { is_open: true, open_time: '09:00', close_time: '18:00' },
  friday: { is_open: true, open_time: '09:00', close_time: '18:00' },
  saturday: { is_open: false, open_time: null, close_time: null },
  sunday: { is_open: false, open_time: null, close_time: null },
};

// Form field names
export const FORM_FIELDS = {
  // Partner fields
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phone',
  DESCRIPTION: 'description',
  STATUS: 'status',
  LOGO: 'logo',

  // MAIB fields
  MAIB_MERCHANT_ID: 'maib_merchant_id',
  MAIB_MERCHANT_NAME: 'maib_merchant_name',
  MAIB_TERMINAL_ID: 'maib_terminal_id',
  MAIB_SIGNATURE_KEY: 'maib_signature_key',

  // Clinic fields
  CLINIC_NAME: 'clinic_name',
  ADDRESS: 'address',
  WORKING_HOURS: 'working_hours',
};